import { schema } from 'normalizr';

export const substanceTRSchema = new schema.Entity('substancesTR', {}, { idAttribute: 'SubstanceTRId' });
export const substanceTRListSchema = [substanceTRSchema];
